import React, { useEffect, useState } from "react";
import { getIDronaConfig } from "../../../../api/org-admin";
import Utils from "../../../../utils/Utils";
import {
  getBlueprintJdDetailsApi,
  getInterviewDataApi,
} from "../../../../api/candidate";
import WebUtils from "../../../../utils/WebUtils";
import IDronaConfig from "../schedulePages/IDronaConfig";
import Loader from "../../../Loader";

function InterviewDetails() {
  const userDetail = Utils.getUserDetail();

  const queryParams = new URLSearchParams(window.location.search);
  const jdId = queryParams.get("jdIdentifier");
  const iDronaId = queryParams.get("iDronaId");

  const [loading, setLoading] = useState(false);
  const [jdDetails, setJdDetails] = useState(null);
  const [interviewData, setInterviewData] = useState(null);
  const [tab, setTab] = useState("Interview Status");

  const getJdDetails = () => {
    const url = `${getBlueprintJdDetailsApi}?jdIdentifier=${jdId}&userIdentifier=${
      userDetail?.userIdentifier || null
    }&organizationId=${userDetail?.organizationId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   console.log(result.data);
          setJdDetails(result?.data?.data);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
          setJdDetails(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getJdDetails();
  }, []);

  return (
    <>
      {loading && <Loader />}

      <div className="mt-8">
        <IDronaConfig
          userDetail={userDetail}
          setLoading={setLoading}
          iDronaId={iDronaId}
          jdDetails={jdDetails}
          jdId={jdId}
          interviewDetailsFlag={true}
        />
      </div>
    </>
  );
}

export default InterviewDetails;
